import script from "./ImageLightbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageLightbox.vue?vue&type=script&setup=true&lang=ts"

import "./ImageLightbox.vue?vue&type=style&index=0&id=759ce694&lang=scss"

const __exports__ = script;

export default __exports__